var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 10.6666H22.6668V7.99992C22.6668 4.31992 19.6802 1.33325 16.0002 1.33325C12.3202 1.33325 9.3335 4.31992 9.3335 7.99992V10.6666H8.00016C6.5335 10.6666 5.3335 11.8666 5.3335 13.3333V26.6666C5.3335 28.1333 6.5335 29.3333 8.00016 29.3333H24.0002C25.4668 29.3333 26.6668 28.1333 26.6668 26.6666V13.3333C26.6668 11.8666 25.4668 10.6666 24.0002 10.6666ZM16.0002 22.6666C14.5335 22.6666 13.3335 21.4666 13.3335 19.9999C13.3335 18.5333 14.5335 17.3333 16.0002 17.3333C17.4668 17.3333 18.6668 18.5333 18.6668 19.9999C18.6668 21.4666 17.4668 22.6666 16.0002 22.6666ZM12.0002 10.6666V7.99992C12.0002 5.78659 13.7868 3.99992 16.0002 3.99992C18.2135 3.99992 20.0002 5.78659 20.0002 7.99992V10.6666H12.0002Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.021133e1e854caf9ede90a7a60a7c4cd.svg";
export { ForwardRef as ReactComponent };